import {
  SR_API_ACTION_PARTNER_GET_MARKETING_LISTING,
} from 'api/actionTypes';

export default async function getMartetingListingByListingId(
  { state, apiClient },
  { listingId }
) {
  const statePath = ['partners', 'marketingListingsByListingId', listingId];
  if (state.get(statePath)) {
    return state.get(statePath);
  }

  return apiClient.postWithState({
    action: SR_API_ACTION_PARTNER_GET_MARKETING_LISTING,
    queryId: String(listingId),
    state: state,
    payload: {
      listingId: listingId,
    },
    onSuccess(marketingListing) {
      state.set(statePath, marketingListing);
    },
  });
}
